import Marquee from "react-fast-marquee";

const WORDS = ["Air Freight", "Sea Freight", "Warehousing", "Trucking", "Project Logistics", "Dangerous Goods"];

export const BrandMarquee = () => (
  <section data-testid="marquee" className="py-16 border-y border-white/10 bg-[#050505] overflow-hidden">
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display text-4xl sm:text-6xl uppercase tracking-tighter px-12 ${i % 2 ? "stroke-text" : "text-white"}`}>
            {w}
          </span>
          <span className="h-2 w-2 bg-primary" />
        </span>
      ))}
    </Marquee>
  </section>
);
